<template>
  <div id="app">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import HelloWorld from './components/LiveDisplay.vue'
export default {
  name: 'app',
  components: {
    HelloWorld
  }
}
</script>

<style>
@font-face {
  font-family: ProximaNova-Light;
  src: url('https://cdn.joinfightcamp.com/fonts/ProximaNova-Light.eot');
  src: url('https://cdn.joinfightcamp.com/fonts/ProximaNova-Light.eot?#iefix') format('embedded-opentype'),
       url('https://cdn.joinfightcamp.com/fonts/ProximaNova-Light.woff2') format('woff2'),
       url('https://cdn.joinfightcamp.com/fonts/ProximaNova-Light.woff') format('woff'),
       url('https://cdn.joinfightcamp.com/fonts/ProximaNova-Light.ttf') format('truetype');
  font-display: swap;
}

@font-face {
  font-family: ProximaNova-Bold;
  src: url('https://cdn.joinfightcamp.com/fonts/ProximaNova-Bold.eot');
  src: url('https://cdn.joinfightcamp.com/fonts/ProximaNova-Bold.eot?#iefix') format('embedded-opentype'),
      url('https://cdn.joinfightcamp.com/fonts/ProximaNova-Bold.woff2') format('woff2'),
      url('https://cdn.joinfightcamp.com/fonts/ProximaNova-Bold.woff') format('woff'),
      url('https://cdn.joinfightcamp.com/fonts/ProximaNova-Bold.ttf') format('truetype');
  font-display: swap;

}

@font-face {
  font-family: ProximaNova-Regular;
  src: url('https://cdn.joinfightcamp.com/fonts/ProximaNova-Regular.eot');
  src: url('https://cdn.joinfightcamp.com/fonts/ProximaNova-Regular.eot?#iefix') format('embedded-opentype'),
      url('https://cdn.joinfightcamp.com/fonts/ProximaNova-Regular.woff2') format('woff2'),
      url('https://cdn.joinfightcamp.com/fonts/ProximaNova-Regular.woff') format('woff'),
      url('https://cdn.joinfightcamp.com/fonts/ProximaNova-Regular.ttf') format('truetype');
  font-display: swap;

}




h1, h3 {
  font-family: 'ProximaNova-Bold','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
h2 {
  font-family: 'ProximaNova-Light','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
    letter-spacing: 2px;

}


#app {
  font-family: 'ProximaNova-Light','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

/*
body {
  background-color: #212121;
  background-image:url('assets/fightcamp.svg');
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: auto 80%;
  background-position-y: center center; 
}*/
body {
    background-color: #212121;
  background-image:url('assets/mosaic.svg');
  background-attachment: fixed;
  background-size: 10vw auto;
  background-position-y: center center; 
}
</style>
